import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CreditNoteReasonReferenceService extends BaseReferenceService {
  constructor() {
    super('CreditNoteReasonReference');
  }
}
